<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e638">
<div class="tx45">
<p class="h10" id="d41151751"><b><span style="font-size: 1.40em; ">The Gun Seller </span></b></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap8_thegunse_9781569478004_epub_part8.vue?03e42449